export enum TokenPrices {
  PEARL = 0.01,
  BLACK_PEARL = 0.1,
  COAL = 0.001,
  GOLD_ORE = 0.5,
  WOOD = 0.005,
  IRON_ORE = 0.015,
  SAND = 0.0001,
  CLAY = 0.0035
}

export enum NFTPrices {
  LITTLE_HUT = 23.49125,
  MEDIUM_HUT = 33.097,
  LARGER_HUT = 39.84925,
  SPECIOUS_HUT = 63.079,
  GREAT_HUT = 90.68225,
  LITTLE_BRICK_HUT = 46.167,
  MEDIUM_BRICK_HUT = 67.813,
  LARGER_BRICK_HUT = 97.727,
  SPECIOUS_BRICK_HUT = 155.349,
  GREAT_BRICK_HUT = 231.3335,
  TILED_LITTLE_BRICK_HUT = 152.47,
  TILED_MEDIUM_BRICK_HUT = 228.4825,
  TILED_LARGER_BRICK_HUT = 336.8612,
  TILED_SPECIOUS_BRICK_HUT = 498.8487,
  TILED_GREAT_BRICK_HUT = 716.937
}

export const LEADERBOARD_REWARDS: Record<number, string[]> = {
  1: ['Great brick hut', 'Larger brick hut'],
  2: ['Great brick hut'],
  3: ['Great brick hut'],
  4: ['Specious brick hut', 'Medium brick hut'],
  5: ['Specious brick hut'],
  6: ['Specious brick hut'],
  7: ['Larger brick hut', 'Little brick hut'],
  8: ['Larger brick hut'],
  9: ['Larger brick hut'],
  10: ['Medium brick hut', 'Great hut'],
  11: ['Medium brick hut'],
  12: ['Medium brick hut'],
  13: ['Little brick hut', 'Specious hut'],
  14: ['Little brick hut'],
  15: ['Little brick hut'],
  16: ['Great hut', 'Larger hut'],
  17: ['Great hut'],
  18: ['Great hut'],
  19: ['Specious hut', 'Medium hut'],
  20: ['Specious hut'],
  21: ['Specious hut'],
  22: ['Larger hut', 'Little hut'],
  23: ['Larger hut'],
  24: ['Larger hut'],
  25: ['Medium hut'],
  26: ['Medium hut'],
  27: ['Medium hut'],
  28: ['Little hut'],
  29: ['Little hut'],
  30: ['Little hut']
};

/**

Maps NFT display names from LEADERBOARD_REWARDS to NFTPrices enum keys*/
export const NFT_NAME_TO_PRICE_KEY: Record<string, keyof typeof NFTPrices> = {
  'Little hut': 'LITTLE_HUT',
  'Medium hut': 'MEDIUM_HUT',
  'Larger hut': 'LARGER_HUT',
  'Specious hut': 'SPECIOUS_HUT',
  'Great hut': 'GREAT_HUT',
  'Little brick hut': 'LITTLE_BRICK_HUT',
  'Medium brick hut': 'MEDIUM_BRICK_HUT',
  'Larger brick hut': 'LARGER_BRICK_HUT',
  'Specious brick hut': 'SPECIOUS_BRICK_HUT',
  'Great brick hut': 'GREAT_BRICK_HUT',
  'Tiled little brick hut': 'TILED_LITTLE_BRICK_HUT',
  'Tiled medium brick hut': 'TILED_MEDIUM_BRICK_HUT',
  'Tiled larger brick hut': 'TILED_LARGER_BRICK_HUT',
  'Tiled specious brick hut': 'TILED_SPECIOUS_BRICK_HUT',
  'Tiled great brick hut': 'TILED_GREAT_BRICK_HUT'
};

export const LEADERBOARD_REWARDS_100: Record<number, string[]> = {
  1: [
    'Tiled larger brick hut',
    'Tiled larger brick hut',
    'Tiled larger brick hut',
    'Tiled specious brick hut',
    'Tiled specious brick hut',
    'Tiled specious brick hut',
    'Tiled great brick hut',
    'Tiled great brick hut',
    'Tiled great brick hut'
  ],
  2: [
    'Larger brick hut',
    'Tiled specious brick hut',
    'Tiled specious brick hut',
    'Tiled great brick hut',
    'Tiled great brick hut'
  ],
  3: ['Tiled larger brick hut', 'Tiled great brick hut', 'Tiled great brick hut'],
  4: ['Little brick hut', 'Tiled specious brick hut', 'Tiled great brick hut'],
  5: ['Tiled little brick hut', 'Tiled specious brick hut', 'Tiled specious brick hut'],
  6: ['Larger hut', 'Tiled specious brick hut', 'Tiled specious brick hut'],
  7: ['Tiled specious brick hut', 'Tiled specious brick hut'],
  8: ['Great hut', 'Tiled larger brick hut', 'Tiled specious brick hut'],
  9: ['Tiled larger brick hut', 'Tiled specious brick hut'],
  10: ['Tiled larger brick hut', 'Tiled specious brick hut'],
  11: ['Larger hut', 'Tiled medium brick hut', 'Tiled specious brick hut'],
  12: ['Larger hut', 'Tiled larger brick hut', 'Tiled larger brick hut'],
  13: ['Tiled larger brick hut', 'Tiled larger brick hut'],
  14: ['Larger hut', 'Tiled medium brick hut', 'Tiled larger brick hut'],
  15: ['Tiled medium brick hut', 'Tiled larger brick hut'],
  16: ['Specious hut', 'Tiled medium brick hut', 'Tiled medium brick hut'],
  17: ['Medium hut', 'Tiled medium brick hut', 'Tiled medium brick hut'],
  18: ['Tiled medium brick hut', 'Tiled medium brick hut'],
  19: ['Tiled little brick hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  20: ['Larger brick hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  21: ['Little hut', 'Medium brick hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  22: ['Little brick hut', 'Little brick hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  23: ['Specious hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  24: ['Medium hut', 'Tiled little brick hut', 'Tiled little brick hut'],
  25: ['Larger brick hut', 'Great brick hut'],
  26: ['Medium brick hut', 'Great brick hut'],
  27: ['Larger hut', 'Great brick hut'],
  28: ['Great brick hut'],
  29: ['Little brick hut', 'Specious brick hut'],
  30: ['Little hut', 'Specious brick hut'],
  31: ['Specious brick hut'],
  32: ['Little hut', 'Larger brick hut'],
  33: ['Little brick hut', 'Medium brick hut'],
  34: ['Larger hut', 'Medium brick hut'],
  35: ['Medium hut', 'Medium brick hut'],
  36: ['Little brick hut', 'Little brick hut'],
  37: ['Great hut'],
  38: ['Little hut', 'Specious hut'],
  39: ['Larger hut', 'Larger hut'],
  40: ['Medium hut', 'Larger hut'],
  41: ['Medium hut', 'Medium hut'],
  42: ['Medium hut', 'Medium hut'],
  43: ['Little hut', 'Medium hut'],
  44: ['Little hut', 'Medium hut'],
  45: ['Little hut', 'Little hut'],
  46: ['Little hut', 'Little hut'],
  47: ['Little hut', 'Little hut'],
  48: ['Little hut', 'Little hut'],
  49: ['Little hut', 'Little hut'],
  50: ['Little hut', 'Little hut'],
  51: ['Little hut', 'Little hut'],
  52: ['Little hut', 'Little hut'],
  53: ['Little hut', 'Little hut'],
  54: ['Little hut', 'Little hut'],
  55: ['Little hut', 'Little hut'],
  56: ['Little hut', 'Little hut'],
  57: ['Little hut', 'Little hut'],
  58: ['Little hut', 'Little hut'],
  59: ['Little hut', 'Little hut'],
  60: ['Little hut', 'Little hut'],
  61: ['Little hut', 'Little hut'],
  62: ['Little hut', 'Little hut'],
  63: ['Little hut', 'Little hut'],
  64: ['Little hut', 'Little hut'],
  65: ['Little hut', 'Little hut'],
  66: ['Little hut', 'Little hut'],
  67: ['Little hut', 'Little hut'],
  68: ['Little hut', 'Little hut'],
  69: ['Little hut', 'Little hut'],
  70: ['Little hut', 'Little hut'],
  71: ['Little hut', 'Little hut'],
  72: ['Little hut', 'Little hut'],
  73: ['Little hut', 'Little hut'],
  74: ['Little hut', 'Little hut'],
  75: ['Little hut', 'Little hut'],
  76: ['Little hut', 'Little hut'],
  77: ['Little hut', 'Little hut'],
  78: ['Little hut', 'Little hut'],
  79: ['Little hut', 'Little hut'],
  80: ['Little hut', 'Little hut'],
  81: ['Little hut', 'Little hut'],
  82: ['Little hut', 'Little hut'],
  83: ['Little hut', 'Little hut'],
  84: ['Little hut', 'Little hut'],
  85: ['Little hut', 'Little hut'],
  86: ['Little hut', 'Little hut'],
  87: ['Little hut', 'Little hut'],
  88: ['Little hut', 'Little hut'],
  89: ['Little hut', 'Little hut'],
  90: ['Little hut', 'Little hut'],
  91: ['Little hut', 'Little hut'],
  92: ['Little hut', 'Little hut'],
  93: ['Little hut', 'Little hut'],
  94: ['Little hut', 'Little hut'],
  95: ['Little hut', 'Little hut'],
  96: ['Little hut', 'Little hut'],
  97: ['Little hut', 'Little hut'],
  98: ['Little hut', 'Little hut'],
  99: ['Little hut', 'Little hut'],
  100: ['Little hut', 'Little hut']
};
